<script setup>
import { inject, ref, onMounted, computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: null
  }
})

const index = ref(0);
const activeIndex = inject('activeIndex')

const isActive = computed(() => {
  return index.value === activeIndex.value
})

const registerPage = inject('registerPage')

onMounted(() => {
  index.value = registerPage({
    title: props.title,
  })
});
</script>

<template>
  <div v-show="isActive">
    <h3 v-if="title">
      {{ title }}
    </h3>
    <slot />
  </div>
</template>

<style scoped>

</style>
